import { axiosHttp } from "@/util/axios.js";
import { sessionSto } from "../../util/sessionStorageManage.js";

/**
 * 获取首页商品展示
 */
export function getIndexGoods() {
  return axiosHttp.$getAxios("/access/getIndexGoods");
}

/**
 * 获得展示商品信息
 */
export function getGoodsShowing() {
  return axiosHttp.$getAxios("/access/getGoodsShowing");
}

/**
 * 获取商品详细信息
 * @param { goodsNo } data
 */
export function getGoodsInfo(data) {
  return axiosHttp.$getAxios("/access/getGoodsInfo", data);
}

/**
 * 获取商品售后保障政策
 * @param { goodsNo } data
 */
export function getAfterSalePolicy(data) {
  return axiosHttp.$getAxios("/access/getAfterSalePolicy", data);
}

/**
 * 获取商品评论
 * @param { goodsNo } data
 */
export function getGoodsEvaluate(data) {
  return axiosHttp.$getAxios("/access/getGoodsEvaluate", data);
}

/**
 * 获取产品分类信息
 */
export async function getGoodsCategory() {
  let resList = [];
  let res = await axiosHttp.$getAxios("/access/getGoodsCategory");
  resList = res.data;
  return resList;
}

/**
 * 获取分类检索信息
 * @param { prentno } data
 */
export async function getGoodsCondition(no) {
  const data = {
    prentno: no
  };
  let productType = [];
  await axiosHttp.$getAxios("/access/getGoodsCondition", data).then(res => {
    let typeStrs = Object.keys(res.data);
    for (let i = 0; i < typeStrs.length; i++) {
      productType.push({
        typeTitle: typeStrs[i],
        typeList: res.data[typeStrs[i]]
      });
    }
    // 去除空选项
    for (let i = 0; i < productType.length; i++) {
      if (productType[i].typeList.length <= 0) {
        productType.splice(i, 1);
        i--;
      }
    }
  });
  return productType;
}

/**
 * 根据筛选条件获取产品列表
 * @param { priceRange, isLast, classNo } data
 */
export async function getGoodsByCondition(productType, radio, no, orderBy) {
  let i = 0;
  let rData = {};
  productType.forEach(item => {
    switch (item.typeTitle) {
      case "types":
        rData.typesIndex = i;
        break;
      case "ranges":
        rData.rangesIndex = i;
        break;
      default:
        break;
    }
    i++;
  });
  const data = {
    isLast: radio.ranges < 0 && radio.types < 0 ? 0 : 1, // 0: 查询所有，忽略priceRange、classno； 1：依据priceRange、classno查询
    priceRange:
      radio.ranges >= 0
        ? productType[rData.rangesIndex].typeList[radio.ranges].priceRange
        : "",
    classno:
      radio.types >= 0
        ? productType[rData.typesIndex].typeList[radio.types].no
        : no,
    orderBy: orderBy
  };
  let mdList = [];
  await axiosHttp.$getAxios("/access/getGoodsByCondition", data).then(res => {
    mdList = res.data;
    mdList.forEach(item => {
      item.imgUrl =
        "https://yangzi-manage.oss-cn-shanghai.aliyuncs.com/mall/static/assets/MDText.jpg";
      if (!item.retailPrice) {
        item.retailPrice = 0;
      }
    });
  });
  return mdList;
}

// 请求 门店信息 (百度地图)
export function searchDealerList() {
  return axiosHttp.$getAxios("/access/getDealerList");
}

/**
 * 热搜推荐
 * @param { goodsNo } data
 */
export function selectHotsearchClassInfo(data) {
  return axiosHttp.$getAxios("/access/getGoodsHotsearchYzList", data);
}

/**
 * 推荐热卖
 * @param { goodsNo } data
 */
export function selectGoodsHotsearchYzList(data) {
  return axiosHttp.$getAxios("/access/getHotsearchClassInfo", data);
}

/**
 * banner列表获取
 * @param {position：位置} data
 */
export async function getAdvertiseList(data) {
  return axiosHttp.$postAxios("/access/getAdvertiseList", data);
}

/**
 * 客户案例
 * @param {position：位置} data
 */
export function getCustCaseList(data) {
  return axiosHttp.$postAxios("/access/getCustCaseList", data);
  // let res = sessionSto.$selectSession('getCustCaseList')
  // if(res){
  //   res = JSON.parse(res)
  // }else{
  //   res = await axiosHttp.$postAxios("/access/getCustCaseList", data)
  //   if(res.code == 200){
  //     sessionSto.$insertSessionStorage('getCustCaseList', res)
  //   }
  // }
  // return res
}

/**
 * 企业信息
 * @param {position：位置} data
 */
export function getCompanyInfoList(data) {
  return axiosHttp.$postAxios("/access/getCompanyInfoList", data);

  // let res = sessionSto.$selectSession('getCompanyInfoList')
  // if(res){
  //   res = JSON.parse(res)
  // }else{
  //   res = await axiosHttp.$postAxios("/access/getCompanyInfoList", data)
  //   if(res.code == 200){
  //     sessionSto.$insertSessionStorage('getCompanyInfoList', res)
  //   }
  // }
  // return res
}

/**
 * 企业动态
 * @param {position：位置} data
 */
export function getComDynamicList(data) {
  return axiosHttp.$postAxios("/access/getComDynamicList", data);
  // let res = sessionSto.$selectSession('getComDynamicList')
  // if(res){
  //   res = JSON.parse(res)
  // }else{
  //   res = await axiosHttp.$postAxios("/access/getComDynamicList", data)
  //   if(res.code == 200){
  //     sessionSto.$insertSessionStorage('getComDynamicList', res)
  //   }
  // }
  // return res
}



// WEBPACK FOOTER //
// ./src/apis/indexPage/indexPage.js